import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { catchError, retry, map } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { errorMessages } from '@assets/data/constants';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router, location: Location, private toastr: ToastrService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {

        return next.handle(req).pipe(map((event: HttpEvent<any>) => {
            if (event['status'] === 204) {
                this.toastr.warning('No Content Available !', 'HTTP Response ' + event['status']);
                return;
            }
            return event;
        }), catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                /* Do auto login if session is present */
                console.log('Error interceptor: ' + location);
                let redirectPath = location.hash;
                if (location.search) { redirectPath += location.search; }
                this.router.navigate(['login'], { queryParams: { url: redirectPath } });
            } else if (error.status === 400) {
                this.toastr.warning(error.message, error.statusText, {
                    positionClass: 'toast-bottom-full-width'
                });
            } 
            else if (error.status === 412) {
                const message = "You don' have access to manage this entity";
                const messagedeleteMap = "Environment mapper is used in Global test data input files, Can not be deleted";
                if(error.error.message === message){
                  this.router.navigate(['/unauthorized']);
                }
                else {
                    if (
                        error.error.message !== errorMessages.associatedGlobalTestData &&
                        error.error.message !== errorMessages.associatedGlobalInputKey &&
                        error.error.message !== errorMessages.associatedGlobalInputFile
                    ) {
                        this.toastr.error(error.error.errorMessage || error.error.message, error.error.errorStatus);
                    }
                }
            } 
            else if (error.status === 500 || error.status === 406) {
                const reqUrl = req.url.split('/');
                if (reqUrl[reqUrl.length - 3] === 'importExcel') {
                    return throwError(error);
                }
                if (error.error.errorCause && error.error.errorCause !== '' && error.error.errorCause != null) {
                    this.toastr.error(error.error.errorCause, error.error.errorStatus, {
                        positionClass: 'toast-bottom-full-width'
                    });
                } else {
                    this.toastr.error(error.error.errorMessage || error.error.message, error.error.errorStatus);
                }
            } else {
                // this.toastr.error(error.message, '', {
                //     positionClass: 'toast-bottom-full-width'406
                // });
            }
            return throwError(error);
        }));
    }
}
